import React, { useEffect, useState } from "react";
import "./App.css";
import { GRAPHQL_URI, CUSTOMER_GQL_API } from "./constant";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  HttpLink,
} from "@apollo/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setContext } from "@apollo/client/link/context";

import configureStore from "./config/configure-store";
import { getToken } from "./utilities/utilsFunction";
import AppRouter from "./routing/AppRouter";
import { AuthContext } from "./utilities/authContext";

const httpLink = new HttpLink({
  uri: GRAPHQL_URI,
});

const httpLink_dp = new HttpLink({
  uri: CUSTOMER_GQL_API,
});

const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const authToken = await getToken();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: authToken ? authToken : "",
    },
  };
});

const cache = new InMemoryCache();
export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache,
});
export const client_dp = new ApolloClient({
  link: authLink.concat(httpLink_dp),
  cache,
});
const { store } = configureStore();

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));

  const login = () => {
    setIsLoggedIn(true);
  };

  const logout = () => {
    setIsLoggedIn(false);
  };

  useEffect(() => {
    getToken();
  }, []);

  return (
    <Provider store={store}>
      <ApolloProvider client={client}>
        <AuthContext.Provider value={{ login, logout }}>
          <Router>
            <Switch>
              <Route
                path={"/"}
                component={() => <AppRouter isAuthenticated={isLoggedIn} />}
              />
            </Switch>
          </Router>
        </AuthContext.Provider>
        <ToastContainer />
      </ApolloProvider>
    </Provider>
  );
};

export default App;
